export default "__VITE_ASSET__CGdHBZaZ__"